module.exports = __webpack_public_path__ + "img/creditcard-2.6397633d.svg";